import classname from 'classnames';
import React from 'react';
import Tooltip from '@/componentsDS/Tooltip';
import Icon from '@/componentsDS/Icon/Icon';
import { IconSize, IconStyle } from '@/componentsDS/Icon/Icon.type';
import Button from '@/componentsDS/Button/Button';
import { ButtonType, ButtonVariant } from '@/componentsDS/Button/Button.type';
import useEllipsisCheck from '@/hooksDS/use-ellipsis-check/index';
import PropTypes from 'prop-types';


const RenderCell = ({ header, index, row, isHeader, leftFreeze, rightFreeze, headers, handleSort, sortConfig }) => {
	const isFrozenLeft = leftFreeze && index < 1;
	const isFrozenRight = rightFreeze && index >= headers.length - 1;

	const { isEllipsis, elementRefs } = useEllipsisCheck();

	const cellClassName = classname('ds-table__cell', {
		'ds-table__header-cell': isHeader,
		'ds-table__header-cell--sortable': isHeader && header.sortable,
		'ds-table__header-cell--sorted': isHeader && header.key === sortConfig?.key,
		'ds-table__header-cell--asc': isHeader && sortConfig?.direction === 'asc',
		'ds-table__cell--frozen-left': isFrozenLeft,
		'ds-table__cell--frozen-right': isFrozenRight,
		'ds-table__cell--link': row?.link && !header.actionable
	});

	const style = {
		flexBasis: header.width ?? '150px',
		minWidth: header.width ?? '150px',
		...(isFrozenLeft && { left: `56px` }),
		...(isFrozenRight && { right: `0px` }) 
	};

	const styleText = {
		flexBasis: (header?.width && header.width) || '150px'
	};

	if (isHeader) {
		const headerContent = (
			<>
				<div className="ds-table__header-cell__label__left">
					<span className="ds-table__label">{header.label}</span>
					{header.subLabel && <span className="ds-table__sub-label">{header.subLabel}</span>}
				</div>
				{header.info && (
					<div className="ds-table__header-cell__info">
						<Tooltip id={'ds-table__header__tooltip__' + index} content={header.info} placement={'bottom'} portal={true}>
							<Icon name="information-circle" size={IconSize.SMALL} style={IconStyle.SOLID} />
						</Tooltip>
					</div>
				)}
			</>
		);

		return (
			<div className={cellClassName} style={style}>
				{header.sortable ? (
					<Button
						variant={ButtonVariant.UTILITY}
						type={ButtonType.UTILITY}
						onClick={() => header.sortable && handleSort(header.key)}
						text={
							<div className="ds-table__header-cell__wrapper">
								{headerContent}

								<div className="ds-table__header-cell__sort-icon ds-table__header-cell__label__right">
									{header.sortable && header.key === sortConfig?.key && <Icon name="arrow-small-down" size={IconSize.MEDIUM} style={IconStyle.OUTLINED} />}

									{header.sortable && header.key !== sortConfig?.key && <Icon name="arrows-up-down" size={IconSize.MEDIUM} style={IconStyle.OUTLINED} />}
								</div>
							</div>
						}
					/>
				) : (
					<div className="ds-table__header-cell__wrapper">{headerContent}</div>
				)}
				<div className="ds-table__header-cell__right-line" />
			</div>
		);
	} else {
		return (
			<div className={cellClassName} style={style}>
				<div className="ds-table__cell__text" style={styleText}>
					{!header.render && (
						//TODO - Add Tooltip
						<Tooltip id={`ds-table__cell__tooltip__${index}`} content={row ? (row[header.key]) : ''} disabled={!isEllipsis} portal={true}>
							{row?.link && !header.actionable ? (
								<a href={row.link} ref={(el) => (elementRefs.current[index] = el)}>
									{row[header.key]}
								</a>
							) : (
								<div ref={(el) => (elementRefs.current[index] = el)}>{row ? (row[header.key]) : null}</div>
							)}
						</Tooltip>
					)}

					{header.render && (row ? header.render(row[header.key], row) : null)}
				</div>
			</div>
		);
	}
};

export default RenderCell;


RenderCell.propTypes = {
	row: PropTypes.object,
	header: PropTypes.object,
	index: PropTypes.number,
	isHeader: PropTypes.bool,
	handleSort: PropTypes.func,
	sortConfig: PropTypes.object,
	rightFreeze: PropTypes.bool,
	leftFreeze: PropTypes.bool,
	headers: PropTypes.array
}